export function getBrandBadgeClass(brand) {
  const normalizedBrand = (brand || '').toString().trim();

  if (normalizedBrand === 'Raw') return 'brand-badge brand-badge-raw';
  if (normalizedBrand === 'SmackDown') return 'brand-badge brand-badge-smackdown';
  if (normalizedBrand === 'NXT') return 'brand-badge brand-badge-nxt';

  return 'brand-badge brand-badge-neutral';
}
